import { module } from "angular";
import { ConfirmationModalComponent } from "./ConfirmationModalComponent";

module("mmGui").component("mmConfirmationModal", new ConfirmationModalComponent());
